import { render, staticRenderFns } from "./LuogoVisione.vue?vue&type=template&id=3e0b4509"
import script from "./LuogoVisione.vue?vue&type=script&lang=ts"
export * from "./LuogoVisione.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports